import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

/** The result of the evidence for a resolution: the holder of an Account, and
 *  the manager of a Portfolio, share one vocabulary. */
export const resolutionStatusSchema = z.enum(['resolved', 'unresolved', 'conflict']);
export type ResolutionStatus = z.infer<typeof resolutionStatusSchema>;

export const holderResolutionStatusSchema = resolutionStatusSchema;
export type HolderResolutionStatus = ResolutionStatus;

export const accountStatusSchema = z.enum(['active', 'orphaned']);
export type AccountStatus = z.infer<typeof accountStatusSchema>;

export const accountRowSchema = z.object({
    accountId: z.string(),
    clientId: z.string().nullable(),
    clientName: z.string().nullable(),
    holderResolutionStatus: holderResolutionStatusSchema,
    status: accountStatusSchema,
    provider: z.string().nullable(),
    displayReference: z.string().nullable(),
    portfolioCount: z.number().int(),
    hasSuitabilityRecord: z.boolean(),
});
export type AccountRow = z.infer<typeof accountRowSchema>;

export const accountsStatsSchema = z.object({
    total: z.number().int(),
    linked: z.number().int(),
    orphaned: z.number().int(),
    totalPortfolios: z.number().int(),
});
export type AccountsStats = z.infer<typeof accountsStatsSchema>;

export const listAccountsResponseSchema = z.object({
    rows: z.array(accountRowSchema),
    stats: accountsStatsSchema,
});
export type ListAccountsResponse = z.infer<typeof listAccountsResponseSchema>;

export const accountsContract = c.router(
    {
        listAccounts: {
            method: 'GET',
            path: '/accounts',
            query: z
                .object({
                    search: z.string().optional(),
                    status: accountStatusSchema.optional(),
                    holderResolutionStatus: holderResolutionStatusSchema.optional(),
                })
                .optional(),
            responses: { 200: listAccountsResponseSchema },
            summary: 'Account directory',
        },
    },
    { pathPrefix: '/api', strictStatusCodes: false },
);
